import RicmsService from "../../../../services/RicmsService";
import AuditoriaService from "../../../../services/AuditoriaService.js";

export default class ApiService {
  constructor(messages) {
    this.messages = messages;
  }

  async getNotes({ idEmpresa, dtInicial, sped }) {
    try {
      const data = await AuditoriaService.getNotesToSTApuration({
        idEmpresa,
        dtInicial,
        sped,
      });
      const { body } = data;
      return body;
    } catch (e) {
      throw new Error(
        this.messages
          .error(e.message || e.data.message)
          .toast("Não foi possivel buscar notas!"),
      );
    }
  }

  async getItensSPED({ idReg0000, idRegC100 }) {
    try {
      const data = await AuditoriaService.getItensSPEDNotesSTApuration(
        idReg0000,
        idRegC100,
      );
      return data.body;
    } catch (e) {
      throw new Error(
        this.messages
          .error(e.message || e.data.message)
          .toast("Erro ao buscar produtos ddo SPED."),
      );
    }
  }

  async getItensXML({ idNfe, aliquota }) {
    try {
      const data = await AuditoriaService.getItensXMLNotesSTApuration(
        idNfe,
        aliquota,
      );
      return data.body;
    } catch (e) {
      throw new Error(
        this.messages
          .error(e.message || e.data.message)
          .toast("Erro ao buscar produtos da XML."),
      );
    }
  }

  async getSubstituicao(fts) {
    try {
      const { body } = await RicmsService.getSubstituicao(fts, 0);
      return body.data;
    } catch (e) {
      throw new Error(
        this.messages
          .error(e.message || e.data.message)
          .toast("Não foi possível efetuar a busca de Itens Substituição."),
      );
    }
  }

  async getPauta(param) {
    try {
      const data = await RicmsService.getProductPautaByNcmOrDescription(param);
      if (!data.body.length) return;
      return data.body;
    } catch (e) {
      throw new Error(
        this.messages
          .error(e.message || e.data.message)
          .toast("Não foi possível efetuar a busca de Itens da Pauta."),
      );
    }
  }

  async getReducao(param) {
    try {
      const data = await RicmsService.getReducaoByNcm(param);
      return data.body;
    } catch (e) {
      throw new Error(
        this.messages
          .error(e.message || e.data.message)
          .toast("Não foi possível efetuar a busca de Itens Redução."),
      );
    }
  }

  async getAliqDif(param) {
    try {
      const data = await RicmsService.getDiferenciadaByNcm(param);
      return data.body;
    } catch (e) {
      throw new Error(
        this.messages
          .error(e.message || e.data.message)
          .toast(
            "Não foi possível efetuar a busca de Itens Alíquota Diferenciada.",
          ),
      );
    }
  }

  async getPobreza(param) {
    try {
      const { data } = await RicmsService.getPobrezaByNcm(param);
      return data.data;
    } catch (e) {
      throw new Error(
        this.messages
          .error(e.message || e.data.message)
          .toast("Não foi possível efetuar a busca de Itens Pobreza."),
      );
    }
  }

  async insertReference(param) {
    try {
      await AuditoriaService.insertReferenceService(param);
    } catch (e) {
      throw new Error(
        this.messages
          .error(e.message || e.data.message)
          .toast("Não foi possível efetuar a referenciação."),
      );
    }
  }

  async insertStApured(param) {
    try {
      const { data } = await AuditoriaService.insertStApured(param);
      return data;
    } catch (e) {
      throw new Error(
        this.messages
          .error(e.message || e.data.message)
          .toast("Não foi possível efetuar o calculo."),
      );
    }
  }

  async deleteReference(param, idEmpresa) {
    try {
      await AuditoriaService.deleteReferenceService({
        ...param,
        idEmpresa,
      });
    } catch (e) {
      throw new Error(
        this.messages
          .error(e.message || e.data.message)
          .toast("Não foi possível remover a referenciação."),
      );
    }
  }

  async getCalcIcmsSt(param, idEmpresa) {
    try {
      const { cProd, idItem } = param;
      const { data: [data] = {} } = await AuditoriaService.getCalcIcmsSt({
        ...param,
        idEmpresa,
      });
      return {
        cProd,
        idItem,
        vlIcmsDar: parseFloat(data.vlIcmsSt.toFixed(2)),
        vlPobreza: parseFloat(data.vlPobreza.toFixed(2)),
      };
    } catch (e) {
      throw new Error(
        this.messages
          .error(e.message || e.data.message)
          .toast("Não foi possível efetuar o calculo."),
      );
    }
  }

  async retrieveConvenio(param) {
    try {
      const { data } = await AuditoriaService.retrieveConvenio(param);
      return data;
    } catch (e) {
      throw new Error(
        this.messages
          .error(e.message || e.data.message)
          .toast("Não foi possível efetuar a busca do Convênio."),
      );
    }
  }

  async referenceConvenio(param) {
    try {
      const { data } = await AuditoriaService.referenceConvenio(param);
      return data;
    } catch (e) {
      throw new Error(
        this.messages
          .error(e.message || e.data.message)
          .toast("Não foi possível referenciar o item como convênio."),
      );
    }
  }
}
